import { useAppDispatch, useAppSelector } from "../../ReduxToolkit/Hooks";
import { OpenCloseSidebar } from "../../ReduxToolkit/Reducers/Messenger/Messenger";

const SidebarSetting = () => {
  const dispatch = useAppDispatch();
  const { sidebarToggle } = useAppSelector((state) => state.messenger);
  return (
    <div className="sidebar-setting">
      <h5>Sidebar</h5>
      <ul>
        <li className={`three-column ${sidebarToggle === false ? "active" : ""}`} onClick={() => dispatch(OpenCloseSidebar(true))}>
          <div className="sm-sidebar" />
          <div className="sidebar" />
          <div className="sidebar-content" />
        </li>
        <li className={`two-column ${sidebarToggle === true ? "active" : ""}`}>
          <div className="sidebar" />
          <div className="sidebar-content" onClick={() => dispatch(OpenCloseSidebar(false))} />
        </li>
      </ul>
    </div>
  );
};

export default SidebarSetting;
